export const searchText = (value) => {
  return value?.toLowerCase() === 'remote' ? '' : value
}
